module.exports = __webpack_public_path__ + "img/care_blue.a8aee271.png";